import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { EncodingDataService } from './encoding-data.service';
import { StoreCurrentUserService } from './store-current-user.service';
import { TokenInterface } from '../interfaces/token.interface';
const Swal = require('sweetalert2');

@Injectable()
export class GlobalHttpInterceptorService implements HttpInterceptor {
    constructor(
        private router: Router,
        private toastr: ToastrService,
        private loadingBar: LoadingBarService,
        private encodingService: EncodingDataService,
        private currentUserService: StoreCurrentUserService
    ) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (req.url.includes('/assets/i18n/')) {
            return next.handle(req);
        }

        this.loadingBar.start();

        const token = this.encodingService.getData(
            'token_data'
        ) as TokenInterface | null;
        const authReq = token
            ? req.clone({
                  setHeaders: { Authorization: `Bearer ${token.value}` },
              })
            : req;

        return next.handle(authReq).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error instanceof HttpErrorResponse) {
                    switch (error.status) {
                        case 401:
                            this.handleUnauthorized(token);
                            break;

                        case 403:
                            this.toastr.warning('Accès refusé.');
                            break;

                        case 404:
                            this.toastr.error('Ressource introuvable.');
                            break;

                        case 422:
                            // this.toastr.warning(
                            //     'Certaines données sont invalides.'
                            // );
                            break;

                        case 500:
                            this.toastr.error('Erreur interne du serveur.');
                            break;

                        default:
                            this.toastr.error(
                                error.error?.message ||
                                    'Une erreur est survenue.'
                            );
                            break;
                    }
                }
                return throwError(() => error);
            }),

            finalize(() => {
                this.loadingBar.complete();
            })
        );
    }

    private handleUnauthorized(token: TokenInterface | null): void {
        if (token) {
            [
                'token_data',
                'menu',
                'dashboard_links',
                'user_data',
                'modules',
            ].forEach((key) => this.encodingService.removeData(key));

            this.router
                .navigateByUrl('auth/login')
                .then(() => window.location.reload());
        } else {
            this.loadingBar.stop();
            this.toastr.error('Session expirée. Veuillez vous reconnecter.');
        }
    }

    private errorMessages() {
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: "Une erreur s'est produite!",
            footer: '<a href="#">Contactez-nous pour plus d\'informations</a>',
        });
    }
}
